import emailValidator from 'email-validator';

const validatorMethods = {
  isBoolean: (val) => Boolean(val),
  isEmail: (str) => emailValidator.validate(str),
  isEmpty: (str) => !str.trim().length,
};

class Validator {
  constructor(validations) {
    // validations is a map of validation rules specific to a form
    // field name is the key of the map and a list of rules is value of the map.
    this.validations = validations;
  }

  init = () => {
    const validation = {};
    Object.keys(this.validations).forEach((field) => {
      validation[field] = { isInvalid: false, message: '' };
    });
    return { isValid: true, ...validation };
  };

  validate = (state) => {
    const validation = this.init();
    Object.keys(this.validations).forEach((field) => {
      // determine the field value, the method to invoke and optional args from
      // the rule definition
      const fieldValue = state[field].toString();
      const result = this.isValid(field, fieldValue, state); // { valid:true, message:'' }
      validation[field] = {
        isInvalid: !result.valid,
        message: result.message,
      };
      if (!result.valid) validation.isValid = false;
    });
    return validation;
  };

  isValid = (field, fieldValue, state = {}) => {
    const rules = this.validations[field];
    for (let i = 0; i < rules.length; i += 1) {
      const rule = rules[i];
      const args = rule.args || [];
      // call the validationMethod with the current field value as the first
      // argument, any additional arguments, and the whole state as a final
      // argument.  If the result doesn't match the rule.validWhen property,
      // then modify the validation object for the field and set the isValid
      // field to false
      const validationMethod =
        typeof rule.method === 'string'
          ? validatorMethods[rule.method]
          : rule.method;
      if (validationMethod(fieldValue, ...args, state) !== rule.validWhen) {
        return { valid: false, message: rule.message };
      }
    }
    return {
      valid: true,
      message: '',
    };
  };
}

export default Validator;
